import React, { Component } from 'react';
import { BoxIcon, ChevronRight } from 'lucide-react';
interface MetricTileProps {
  title: string;
  points: number;
  count: number;
  countLabel: string;
  icon: BoxIcon;
  colorClass: string;
  bgClass: string;
  ptsPerAction?: number;
  onClick?: () => void;
  countSuffix?: string;
  hidePoints?: boolean;
}
export function MetricTile({
  title,
  points,
  count,
  countLabel,
  icon: Icon,
  colorClass,
  bgClass,
  ptsPerAction,
  onClick,
  countSuffix,
  hidePoints
}: MetricTileProps) {
  const clickable = !!onClick;
  const Component = clickable ? 'button' : 'div';
  return <Component {...clickable ? {
    onClick,
    type: 'button' as const,
    'aria-label': `View ${count} ${countLabel.toLowerCase()} detail`
  } : {}} className={`group relative bg-white border border-gray-200 rounded-xl p-4 pt-5 flex flex-col items-center text-center shadow-sm transition-all w-full ${clickable ? 'hover:shadow-md hover:border-blue-300 hover:-translate-y-0.5 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500' : ''}`} data-id="element-371">
      {clickable && <ChevronRight className="absolute top-2 right-2 w-3.5 h-3.5 text-gray-300 group-hover:text-blue-500 transition-colors" data-id="element-372" />}
      <div className={`w-12 h-12 rounded-full ${bgClass} ${colorClass} flex items-center justify-center mb-3 shrink-0`} data-id="element-373">
        <Icon className="w-6 h-6" data-id="element-374" />
      </div>
      <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-2 leading-tight" data-id="element-375">
        {title}
      </h4>
      {!hidePoints && <>
          <div className="flex items-baseline gap-1 mb-3" data-id="element-376">
            <span className={`text-2xl font-extrabold ${colorClass} leading-none`} data-id="element-377">
              {points}
            </span>
            <span className="text-xs font-bold text-gray-500" data-id="element-378">PTS</span>
          </div>
          <div className="w-full h-px bg-gray-100 mb-3" data-id="element-379"></div>
        </>}
      <div className="flex flex-col items-center" data-id="element-380">
        <span className={`${hidePoints ? 'text-3xl' : 'text-lg'} font-bold text-[#0a1e5e] leading-tight`} data-id="element-381">
          {count}
          {countSuffix}
        </span>
        <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider leading-tight mt-0.5" data-id="element-382">
          {countLabel}
        </span>
      </div>
      {ptsPerAction && !hidePoints && <div className="mt-3 pt-3 border-t border-gray-100 w-full" data-id="element-383">
          <span className={`text-[10px] font-bold uppercase tracking-wider ${colorClass}`} data-id="element-384">
            {ptsPerAction} / {countLabel.replace(/s$/i, '')}
          </span>
        </div>}
    </Component>;
}